export const REQUESTED = "REQUESTED";
export const SUBMITTED = "SUBMITTED";
export const PROCESSING = "PROCESSING";
export const DEPRECATED = "DEPRECATED";
export const ARCHIVED = "ARCHIVED";
export const REVIEW_PENDING = "REVIEW_PENDING";
export const ACCEPTED = "ACCEPTED";

export const SENSITIVE_DATA_LINKED_TYPE = {
  PERSONA: "PERSONA",
  ENTITY: "ENTITY",
  BANK: "BANK",
} as const;

export const SENSITIVE_DATA_OPTION_TYPE = {
  STATIC: "STATIC",
  ENTITY: "ENTITY",
  PROFILE: "PROFILE",
  SERVICE_TEAM: "SERVICE_TEAM",
} as const;

export const AUTOFILL_TIN_SOURCE = "AUTOFILL_TIN";
export const SENSITIVE_DATA_TYPE_CREDENTIALS = "Credentials";

export const TAX_ID_TYPE_OTHER = "OTHER";
export const EFTPS_TYPE_PERSONAL = "PERSONAL";
export const EFTPS_TYPE_BUSINESS = "BUSINESS";

export const SENSITIVE_DATA_LINKED_SECTION_TITLE = {
  PERSONA: "Person Details",
  ENTITY: "Entity Details",
  BANK: "Account Holder",
} as const;

export const SENSITIVE_DATA_TYPE_NAME = {
  PERSONAL_PASSPORT: "Personal Passport",
  PERSONAL_TAX_ID: "Personal Tax ID",
  EFTPS_PIN: "EFTPS Pin",
  CREDENTIALS: "Credentials",
  ACH_DETAILS: "ACH Details",
} as const;

export const SENSITIVE_DATA_TYPE_ID = {
  ACH_DETAILS: "15359af1-d49f-47b8-834c-eece3dd73728",
  CREDENTIALS: "f15c7120-a17c-4331-b556-cf497cf37ade",
  EFTPS_PIN: "b14620ce-880c-40fb-9ec1-886763d6792b",
  PERSONAL_PASSPORT: "4c5119a6-5b90-4eb8-8a5b-32a4477f5e27",
  PERSONAL_TAX_ID: "9ea8e6db-72a8-4bd1-bc9b-314f7de64891",
} as const;

export const SENSITIVE_DATA_BANK_FIELD_LABEL = "Select bank";

export const SENSITIVE_DATA_MODAL_TITLE_BY_TYPE: Record<string, string> = {
  [SENSITIVE_DATA_TYPE_NAME.PERSONAL_TAX_ID]: "Tax ID",
  [SENSITIVE_DATA_TYPE_NAME.EFTPS_PIN]: "EFTPS PIN",
};

export const SENSITIVE_DATA_SECTION_TITLE_BY_ID: Record<string, string> = {
  [SENSITIVE_DATA_TYPE_ID.PERSONAL_PASSPORT]: "Passport Details",
  [SENSITIVE_DATA_TYPE_ID.PERSONAL_TAX_ID]: "Tax ID Details",
  [SENSITIVE_DATA_TYPE_ID.EFTPS_PIN]: "EFTPS Details",
  [SENSITIVE_DATA_TYPE_ID.CREDENTIALS]: "Credential Details",
  [SENSITIVE_DATA_TYPE_ID.ACH_DETAILS]: "Bank Details",
};

export const SENSITIVE_DATA_SECTION_TITLE_BY_TYPE: Record<string, string> = {
  [SENSITIVE_DATA_TYPE_NAME.PERSONAL_PASSPORT]: "Passport Details",
  [SENSITIVE_DATA_TYPE_NAME.PERSONAL_TAX_ID]: "Tax ID Details",
  [SENSITIVE_DATA_TYPE_NAME.EFTPS_PIN]: "EFTPS Details",
  [SENSITIVE_DATA_TYPE_NAME.CREDENTIALS]: "Credential Details",
  [SENSITIVE_DATA_TYPE_NAME.ACH_DETAILS]: "Bank Details",
};

export const SENSITIVE_DATA_DEFAULT_SECTION_TITLE = "Details";

export const BANK_ACCOUNT_ERROR_FIELD_BY_CODE: Record<string, string> = {
  account_number_required: "account_number",
  account_holder_address_required: "address",
};

export const SENSITIVE_DATA_MASKED_VALUE = "**********";

export const SENSITIVE_DATA_KEEP_VALUE_HINT =
  "Leave blank to keep the saved value";

export const SENSITIVE_DATA_ROW_COPY_FIELD_KEY_BY_TYPE: Record<string, string> =
  {
    [SENSITIVE_DATA_TYPE_NAME.ACH_DETAILS]: "routing_number",
  };

export const SENSITIVE_DATA_BOOLEAN_YES = "Yes";
export const SENSITIVE_DATA_BOOLEAN_NO = "No";
export const SENSITIVE_DATA_NO_VALUE = "-";

export const SENSITIVE_DATA_PASSWORD_FIELD_KEY = "password";

export const SENSITIVE_DATA_BANK_AUTOFILL_KEY = "bank_accounts";

export const SENSITIVE_DATA_BANK_ENTRY_MODE = {
  SAVED: "SAVED",
  MANUAL: "MANUAL",
} as const;

export const SENSITIVE_DATA_BANK_ENTRY_MODE_KEY = "bank_entry_mode";
export const SENSITIVE_DATA_MANUAL_BANK_KEY = "manual_bank";

export const SENSITIVE_DATA_SAVED_BANK_HINT =
  "Select a bank account already connected to this entity. We'll fetch its verified ACH details.";
